import { ArrowUpRight } from "lucide-react";
import { AMAZON_URL, BOOK2_URL, AURORA_BG } from "@/constants/site";
import { MaskedLine, FadeUp } from "./Reveal";

export const Finale = () => (
  <section data-testid="finale-section" className="relative py-32 md:py-44 overflow-hidden">
    <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
      <img src={AURORA_BG} alt="" className="w-full h-full object-cover object-bottom opacity-25" loading="lazy" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-[#050505]/70 to-[#050505]" />
    </div>

    <div className="relative max-w-[1400px] mx-auto px-6 lg:px-12">
      <FadeUp>
        <span className="font-tech text-[11px] uppercase tracking-[0.3em] text-sky-400">
          Aurora Unbound — Out Now
        </span>
      </FadeUp>
      <h2 className="font-display font-light tracking-tighter leading-[0.98] text-[clamp(2.8rem,8vw,7.5rem)] mt-8">
        <MaskedLine delay={0.1}>Step into</MaskedLine>
        <MaskedLine delay={0.25}>
          <span className="italic bg-gradient-to-r from-sky-400 to-emerald-400 bg-clip-text text-transparent">
            the light.
          </span>
        </MaskedLine>
      </h2>
      <FadeUp delay={0.2}>
        <p className="mt-10 max-w-xl text-zinc-300 font-light leading-relaxed text-base md:text-lg">
          Aurora Unbound has landed. Order your copy today — or catch up on where it all
          began with Northern Lights Rising.
        </p>
      </FadeUp>
      <FadeUp delay={0.3}>
        <div className="mt-14 flex flex-wrap items-center gap-6">
          <a
            href={BOOK2_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="finale-buy-button"
            className="group inline-flex items-center gap-3 bg-sky-500 text-black font-tech text-xs uppercase tracking-[0.25em] px-10 py-5 hover:bg-sky-400 hover:-translate-y-0.5 transition-[background-color,transform] duration-300"
          >
            Order Book Two — $29.99
            <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
          <a
            href={AMAZON_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="finale-book-one-link"
            className="group inline-flex items-center gap-3 border border-white/15 text-zinc-200 font-tech text-xs uppercase tracking-[0.25em] px-8 py-5 hover:border-emerald-400/70 hover:text-emerald-300 hover:-translate-y-0.5 transition-[border-color,color,transform] duration-300"
          >
            Get Book One — from $24.99
            <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </div>
      </FadeUp>
    </div>
  </section>
);

export default Finale;
